module.exports = __webpack_public_path__ + "static/media/star-selected.8725b42f.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/star-selected.svg
// module id = 3785
// module chunks = 0